import { FC } from 'react';
import clsx from 'clsx';
import { IButton } from '../../../types';
import styles from './default.module.css';

const Button: FC<IButton> = (props) => {

  const {
    type = 'button',
    className = '',
    size = 'normal',
    fullwidth = false,
    isLoading = false,
    variant = 'default',
    dot,
    children,
    ...rest
  } = props;

  // normalize size
  // eslint-disable-next-line
  const sizeClass = size === 'small' ? 'is-small' : size === 'medium' ? 'is-medium' : size === 'large' ? 'is-large' : 'is-normal';

  const fullwidthClass = fullwidth ? 'is-fullwidth' : '';

  const loadingClass = isLoading ? 'is-loading' : '';

  // eslint-disable-next-line
  const variantClass = variant === 'default' ? '' : styles[variant];

  const hasDotClass = dot ? styles.hasDot : '';

  return (
    <button
      type={type}
      className={clsx(
        'button',
        // sizeClass,
        fullwidthClass,
        styles.base,
        loadingClass,
        variantClass,
        hasDotClass,
        className,
      )}
      {...rest}
    >
      {children}
      {Boolean(dot) && <div className={clsx(styles.dot, styles[dot as any])} />}
    </button>
  );

};

export default Button;
